// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sra-container {
  padding: 30px;
  max-width: 700px;
  margin: auto;
}

.sra-textarea {
  width: 100%;
  min-height: 150px;
  padding: 10px;
  border-radius: 6px;
  border: 1px solid #ccc;
  margin-bottom: 20px;
}

.sra-project-section {
  margin-top: 20px;
}

.sra-input,
.sra-select {
  width: 100%;
  padding: 8px;
  border-radius: 6px;
  border: 1px solid #ccc;
  margin-bottom: 12px;
}

.sra-divider {
  text-align: center;
  margin: 10px 0;
  font-weight: bold;
}

.sra-import-btn {
  padding: 12px 20px;
  background-color: #8a2be2;
  color: white;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  margin-top: 20px;
}

.sra-confirm-btn {
  padding: 10px 16px;
  background-color: #28a745;
  color: white;
  border: none;
  border-radius: 6px;
  cursor: pointer;
}

/* Modal */
.sra-modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,0.45);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2000;
}

.sra-modal-box {
  background: white;
  padding: 20px;
  border-radius: 8px;
  width: 720px;
  max-width: 92%;
  max-height: 88vh;        /* never taller than the viewport */
  overflow-y: auto;        /* scroll if content still overflows */
  display: flex;
  flex-direction: column;
}

.sra-modal-close {
  margin-top: 20px;
  padding: 8px 14px;
  background: #6c757d;
  color: white;
  border: none;
  border-radius: 6px;
  cursor: pointer;
}

.sra-button-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 25px;
}

.sra-previous-btn {
  background-color: #4a90e2;
  color: white;
  padding: 10px 18px;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 15px;
  /* font-weight: 600; */
}

.sra-previous-btn:hover {
  background-color: #3b7ac0;
}
`, "",{"version":3,"sources":["webpack://./src/css/SraImportPage.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA,UAAU;AACV;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,4BAA4B;EAC5B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,YAAY;EACZ,cAAc;EACd,gBAAgB,SAAS,mCAAmC;EAC5D,gBAAgB,SAAS,sCAAsC;EAC/D,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":[".sra-container {\n  padding: 30px;\n  max-width: 700px;\n  margin: auto;\n}\n\n.sra-textarea {\n  width: 100%;\n  min-height: 150px;\n  padding: 10px;\n  border-radius: 6px;\n  border: 1px solid #ccc;\n  margin-bottom: 20px;\n}\n\n.sra-project-section {\n  margin-top: 20px;\n}\n\n.sra-input,\n.sra-select {\n  width: 100%;\n  padding: 8px;\n  border-radius: 6px;\n  border: 1px solid #ccc;\n  margin-bottom: 12px;\n}\n\n.sra-divider {\n  text-align: center;\n  margin: 10px 0;\n  font-weight: bold;\n}\n\n.sra-import-btn {\n  padding: 12px 20px;\n  background-color: #8a2be2;\n  color: white;\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n  margin-top: 20px;\n}\n\n.sra-confirm-btn {\n  padding: 10px 16px;\n  background-color: #28a745;\n  color: white;\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n}\n\n/* Modal */\n.sra-modal-backdrop {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0,0,0,0.45);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 2000;\n}\n\n.sra-modal-box {\n  background: white;\n  padding: 20px;\n  border-radius: 8px;\n  width: 720px;\n  max-width: 92%;\n  max-height: 88vh;        /* never taller than the viewport */\n  overflow-y: auto;        /* scroll if content still overflows */\n  display: flex;\n  flex-direction: column;\n}\n\n.sra-modal-close {\n  margin-top: 20px;\n  padding: 8px 14px;\n  background: #6c757d;\n  color: white;\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n}\n\n.sra-button-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-top: 25px;\n}\n\n.sra-previous-btn {\n  background-color: #4a90e2;\n  color: white;\n  padding: 10px 18px;\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 15px;\n  /* font-weight: 600; */\n}\n\n.sra-previous-btn:hover {\n  background-color: #3b7ac0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
